export default __webpack_public_path__ + "static/media/landing-page-right-square-image.d509b19f.png";